module.exports = __webpack_public_path__ + "media/When You Tell Me That You Love Me.4ed903a1.mp3";